import "./MobileMenuItem.css";
import React from "react";
import PropTypes from "prop-types";
import HeaderItem from "../../mixins/HeaderItem";
import autobind from "autobind-decorator";
import { KEYCODES } from "util/constants";
import RequestDemoButton from "shared/components/marketing/RequestDemoButton";

class MobileMenuItem extends React.Component {
    static propTypes = {
        url: PropTypes.string.isRequired
    };

    @autobind
    handleMenuToggle(e) {
        this.handleClick(e);
        this.props.handleMobileMenuClick();
    }

    @autobind
    handleKeyUp(e) {
        if (e.keyCode === KEYCODES.ENTER) {
            e.preventDefault();
            this.handleClick(e);
            this.props.handleMobileMenuClick();
        }
    }

    siteLogo(isLoggedIn) {
        return <div className={isLoggedIn ? "site-logo" : "site-logo-marketing"} />;
    }

    render() {
        const {
            isLoggedIn,
            requestInfoUrl
        } = this.props;
        
        return (
            <div className="mobile-menu-container">
                <div className={isLoggedIn ? "mobile-header-container" : "mobile-header-container-marketing"}>
                    <a className="site-logo-container" aria-label="Gradifi" href={this.props.url}>
                        {this.siteLogo(isLoggedIn)}
                    </a>
                    <div className="mobile-buttons-section">
                        {!isLoggedIn &&
                            <RequestDemoButton url={requestInfoUrl} />
                        }
                        <div className="spacer" />
                        <div
                            onClick={this.handleMenuToggle}
                            className={isLoggedIn ? "menu-button" : "menu-button-marketing"}
                            onKeyUp={this.handleKeyUp}
                            role="button"
                            tabIndex={0}
                        >
                            <div className={isLoggedIn ? "menu-toggle" : "menu-toggle-marketing"} />
                        </div>
                    </div>
                </div>
                {this.showChildren &&
                    <div className="menu-overlay" />
                }
            </div>
        );
    }
}

export default HeaderItem(MobileMenuItem, "mobile-menu-item");
